// extracted by mini-css-extract-plugin
export default {"l":"a62ccf2c0c"};